import { render, staticRenderFns } from "./editbreedplan.vue?vue&type=template&id=01612eff&scoped=true&"
import script from "./editbreedplan.vue?vue&type=script&lang=js&"
export * from "./editbreedplan.vue?vue&type=script&lang=js&"
import style0 from "./editbreedplan.vue?vue&type=style&index=0&id=01612eff&lang=scss&scoped=true&"
import style1 from "./editbreedplan.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01612eff",
  null
  
)

export default component.exports